module.exports = __webpack_public_path__ + "images/profile-venue.png?ecdc0";